export enum FileUploadAcceptAttribute {
  // Excel 97-2003
  XLS = 'application/vnd.ms-excel',

  // Excel 2007+
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

  // Image JPEG
  JPEG = 'image/jpeg',

  // Image Png
  PNG = 'image/png'
}
